import React, { useState } from 'react'

import Title from '../../../../../components/form/formik/title'
import TableForm from './table-form'
import IFormPage from '../../../../../interfaces/form-page'

import {
  Container,
} from './styles'
import QRCodeModal from './qrcode-modal'

type IProps = any & IFormPage

const TableEditor = ({
  dataForm,
  onSubmit,
  setData,
  generateQRCodeLoading,
  initialData,
  generateQRCode,
  isToUpdate = false,
  currentTable,
  setCurrentTable,
  errorMessage,
  canAddMoreTable,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggleModal = (table?: any) => {
    if (table) setCurrentTable(table)
    setIsOpen((state) => !state)
  }

  return (
    <Container>
      <Title
        title={isToUpdate ? 'Edite a mesa atual' : 'Crie quantas mesas precisar'}
      />
      <TableForm
        canAddMoreTable={canAddMoreTable}
        dataForm={dataForm}
        generateQRCode={generateQRCode}
        onSubmit={onSubmit}
        initialData={initialData}
        isToUpdate={isToUpdate}
        setData={setData}
        handleToggleModal={handleToggleModal}
        errorMessage={errorMessage}
      />
      <QRCodeModal
        table={currentTable}
        isOpen={isOpen}
        onClose={handleToggleModal}
        onGenerate={generateQRCode}
        isLoading={generateQRCodeLoading}
      />
    </Container>
  )
}

export default TableEditor
